// src/components/Navbar.js
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { logOut } from '../services/auth';
import './Navbar.css';

const Navbar = ({ user }) => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await logOut();
      navigate('/login');
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-brand">
          旅遊規劃
        </Link>
        
        <div className="navbar-menu">
          <Link to="/" className="navbar-item">我的行程</Link>
          <Link to="/public-trips" className="navbar-item">公開行程</Link>
          <Link to="/new-trip" className="navbar-button new-trip-btn">新增行程</Link>
          
          <div className="user-menu">
            <img 
              src={user.photoURL} 
              alt={user.displayName} 
              className="user-avatar"
            />
            <span className="user-name">{user.displayName}</span>
            <button onClick={handleLogout} className="logout-btn">
              登出
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;